import { Link } from "react-router-dom";
import { Instagram, Mail, MessageCircle } from "lucide-react";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Footer() {
  const [content, setContent] = useState({});
  useEffect(() => {
    api.get("/content").then(({ data }) => setContent(data || {})).catch(() => {});
  }, []);

  return (
    <footer className="bg-[#49392F] text-[#F8F5EF] mt-24" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="font-display text-2xl">
            Duo <span className="text-[#C2A064] italic">Áurea</span>
          </div>
          <p className="mt-4 text-[13px] leading-relaxed text-[#F8F5EF]/70">
            Joias delicadas, feitas para serem lembradas. Peças cuidadosamente escolhidas para acompanhar seus momentos.
          </p>
        </div>

        <div>
          <h4 className="text-[11px] tracking-[0.3em] uppercase mb-5 text-[#C2A064]">Navegar</h4>
          <ul className="space-y-3 text-[13px]">
            <li><Link to="/catalogo" className="hover:text-[#C2A064]">Catálogo</Link></li>
            <li><Link to="/catalogo?category=Anéis" className="hover:text-[#C2A064]">Anéis</Link></li>
            <li><Link to="/catalogo?category=Colares" className="hover:text-[#C2A064]">Colares</Link></li>
            <li><Link to="/conta" className="hover:text-[#C2A064]">Minha conta</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-[11px] tracking-[0.3em] uppercase mb-5 text-[#C2A064]">Loja</h4>
          <ul className="space-y-3 text-[13px]">
            <li><Link to="/institucional#sobre" className="hover:text-[#C2A064]">Sobre a marca</Link></li>
            <li><Link to="/institucional#entrega" className="hover:text-[#C2A064]">Entrega</Link></li>
            <li><Link to="/institucional#trocas" className="hover:text-[#C2A064]">Trocas e devoluções</Link></li>
            <li><Link to="/institucional#pagamento" className="hover:text-[#C2A064]">Pagamento</Link></li>
            <li><Link to="/institucional#privacidade" className="hover:text-[#C2A064]">Privacidade</Link></li>
            <li><Link to="/institucional#termos" className="hover:text-[#C2A064]">Termos de uso</Link></li>
            <li><Link to="/institucional#faq" className="hover:text-[#C2A064]">FAQ</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-[11px] tracking-[0.3em] uppercase mb-5 text-[#C2A064]">Fale conosco</h4>
          <ul className="space-y-3 text-[13px]">
            {content.instagram_url && (
              <li>
                <a href={content.instagram_url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:text-[#C2A064]">
                  <Instagram size={14} /> Instagram
                </a>
              </li>
            )}
            {content.whatsapp_number && (
              <li>
                <a href={`https://wa.me/${content.whatsapp_number.replace(/\D/g, "")}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:text-[#C2A064]">
                  <MessageCircle size={14} /> WhatsApp
                </a>
              </li>
            )}
            {content.email && (
              <li>
                <a href={`mailto:${content.email}`} className="inline-flex items-center gap-2 hover:text-[#C2A064]">
                  <Mail size={14} /> {content.email}
                </a>
              </li>
            )}
            <li className="text-[#F8F5EF]/60 pt-2">Atendimento seg–sex, 10h às 18h</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#F8F5EF]/10 py-6 text-center text-[11px] tracking-[0.2em] uppercase text-[#F8F5EF]/60">
        © {new Date().getFullYear()} Duo Áurea Joias — Todos os direitos reservados
      </div>
    </footer>
  );
}
